import { render, staticRenderFns } from "./RegulatoryUpdateAddress.vue?vue&type=template&id=729ffa82&scoped=true&"
import script from "./RegulatoryUpdateAddress.vue?vue&type=script&lang=ts&"
export * from "./RegulatoryUpdateAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ffa82",
  null
  
)

export default component.exports